<template>
  <a-modal
    :title="form.department_id ? '修改部门信息' : '新增部门信息'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    destroyOnClose
    :maskClosable="false"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="部门名称" prop="department_name">
        <a-input v-model="form.department_name" placeholder="请输入部门名称" />
      </a-form-model-item>
      <a-form-model-item label="部门负责人" prop="department_leader">
        <a-input
          v-model="form.department_leader"
          placeholder="请输入部门负责人"
        />
      </a-form-model-item>
      <a-form-model-item label="负责人联系方式" prop="department_phone">
        <a-input
          v-model="form.department_phone"
          placeholder="请输入部门负责人联系方式"
        />
      </a-form-model-item>
      <a-form-model-item
        ref="department_pid"
        label="上级部门"
        prop="department_pid"
      >
        <department-select
          ref="departmentSelect"
          :disabled="form.department_pid == '0'"
          v-model="form.department_pid"
          @change="handleChangeDepartment"
        ></department-select>
      </a-form-model-item>
      <a-form-model-item
        ref="department_remark"
        label="备注"
        prop="department_remark"
      >
        <a-input
          v-model="form.department_remark"
          placeholder="请输入部门备注"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { baseURL } from "@/api/index";
import { mapState } from "vuex";
export default {
  data() {
    return {
      baseURL,
      visible: false,
      confirmLoading: false,
      fileList: [],
      form: {
        department_pid: undefined,
        department_name: "",
        department_logo: "",
        department_leader: "",
        department_phone: "",
        department_remark: "",
        max_devicenotuse: "10",
        max_cernotuse: "10",
      },
      groupList: [],
      loadingGroup: false,
      rules: {
        department_name: [
          {
            required: true,
            message: "请输入部门名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "输入长度为1-32位",
            trigger: "blur",
          },
        ],
        department_pid: {
          required: true,
          message: "请选择所属部门",
          trigger: "blur",
        },
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },
  computed: {
    ...mapState(["token"]),
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.department_id = id;
      if (id) {
        this.$http({
          url: "/admin/department/info",
          method: "post",
          data: {
            department_id: id,
          },
        }).then((res) => {
          this.form = {
            ...res.data,
          };
          if (res.data.department_logo) {
            this.fileList = [
              {
                url: res.data.department_logo,
                response: {
                  url: res.data.department_logo,
                },
                name: "部门LOGO",
                status: "done",
                uid: new Date().getTime() + "",
              },
            ];
          }
        });
      }
    },
    handleChange(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.data.url;
          this.form.department_logo = file.response.data.url;
        }
        return file;
      });

      this.fileList = fileList;
    },
    remove(e) {
      this.form.department_logo = "";
    },
    preview(e) {
      this.$viewerApi({
        images: [e.response.url],
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(this.form);
          this.confirmLoading = true;
          this.$http({
            url: this.form.department_id
              ? "/admin/department/update"
              : "/admin/department/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(
                this.form.department_id ? "修改成功" : "创建成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
      this.fileList = [];
    },
    handleChangeDepartment() {
      this.$nextTick(() => {
        this.$refs.department_id.onFieldBlur();
      });
    },
  },
};
</script>

<style>
</style>